import { ReactNode } from "react";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

interface IMultiValuesCellItemProps {
  title: string;
  value: string | number | ReactNode;
}

const MultiValuesCellItem = ({ title, value }: IMultiValuesCellItemProps) => {
  return (
    <div>
      <Typography
        variant="body3SemiBold"
        component="span"
        sx={{ color: colors.textPlaceholder }}
      >
        {`${title}: `}
      </Typography>
      <Typography
        variant="body3SemiBold"
        component="span"
        sx={{ color: colors.textDark }}
      >
        {value}
      </Typography>
    </div>
  );
};

export default MultiValuesCellItem;
